// tslint:disable-next-line:import-name
import CashDealSummaryContainer from './CashSummary';
// tslint:disable-next-line:import-name
import CashDealSummaryUI, { ICashSummaryUIProps } from './CashSummaryUI';

// tslint:disable-next-line:import-name
import DealSummaryContainer from './Summary';
// tslint:disable-next-line:import-name
import DealSummaryUI, { ISummaryUIProps } from './SummaryUI';

// tslint:disable-next-line:import-name
import ServicesSummaryContainer from './ServicesSummary';
import ServicesSummaryUI from './ServicesSummaryUI';

export const CashDealSummary = {
    Container: CashDealSummaryContainer,
    UI: CashDealSummaryUI
};

export const DealSummary = {
    Container: DealSummaryContainer,
    UI: DealSummaryUI
};

export const ServicesSummary = {
    Container: ServicesSummaryContainer,
    UI: ServicesSummaryUI
};
